import { useCloseCheckoutMutation, useSendMessageMutation } from "../../api/hitl-api";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../store";
import { togglePaymentModal } from "../../store/slices/modalsSlice";
import { MessageCodes } from "../checkout-status";
import { getMainUrl } from "../../shared/consts";

type UseCloseSessionProps = { onStart?: () => void };

export const useCloseSkuInBoxCheckout = (props?: UseCloseSessionProps) => {
  const [close, result] = useCloseCheckoutMutation();
  const [sendMessage] = useSendMessageMutation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { key = "", zoneId = "", storeKey = "" } = useParams();

  const closeSession = () => {
    if (!result.isLoading) {
      props?.onStart?.();
      close(key)
        .unwrap()
        .then(() => {
          dispatch(togglePaymentModal({ open: false, args: null }));
          sendMessage({
            key: key,
            message_codes: [MessageCodes.CheckoutCompleted],
          }).unwrap();
          navigate(getMainUrl({ zoneId, storeKey, mode: "sku-in-box" }));
        });
    }
  };

  return [closeSession, result] as const;
};
